module.exports = __webpack_public_path__ + "static/media/card-blog11.462bf653.jpg";